// extracted by mini-css-extract-plugin
export default {"control":"LanguagePicker_control__0HgGz","label":"LanguagePicker_label__jPy1v","icon":"LanguagePicker_icon__nEOuL"};